module.exports = __webpack_public_path__ + "static/media/Poppins-Bold.e47421f9.otf";